import React, {
	Component
} from 'react';
import axios from 'axios';
import { message ,notification} from 'antd';
import { connect } from 'react-redux'
import cookie from "../utils/cookie";
import API from '../API/api';
import './App.css';
import $ from '$';
import { action as userInfoAction } from '../entry_app';



class Login extends Component {
	constructor(props) {
		super(props);
	}

	state = {
		remember: true,
		msg: '',
	};

	componentDidMount() {
		if(cookie.getData('UCENTER_IUCTOKEN')) {
			this.props.history.push('/');
			return;
		}
		if (!!document.getElementsByClassName('app-container')[0]) {
			document.getElementsByClassName('app-container')[0].style.position = 'static';
		}
		const mobile = cookie.getData('mobile');
		const password = cookie.getData('password');
		if(mobile) {
			$('.login-input-phone').val(mobile);
			$('.login-input-password').val(password);
		}
		$('body').on('keyup', '.login-input', (e) => {
			if(e.keyCode === 13) {
				this.doLogin();
				return;
			}
		});
	}

	/**
	 * 记住密码
	 */
	rememberPassword = () => {
		const {
			remember
		} = this.state;
		this.setState({
			remember: !remember
		});
	};

	/** 登录 */
	doLogin = () => {
		const {
			remember
		} = this.state;
		const mobile = $('.login-input-phone').val();
		const password = $('.login-input-password').val();
		let self=this;
		axios.post(API.LOGIN, {
				user_mobile: mobile,
				user_pass: password,
				remember
			})
			.then((response) => response.data).then((json) => {
				if(json.code === 0) {
					if(json.data.message&&json.data.message.length){
						notification.warning({
						    message: '登录异常提示',
						    description: json.data.message,
						    duration:10
						  });
						
					}
					this.props.getUserInfo();
					this.props.history.push('/');

					if(window.location.hostname === 'localhost') {
						cookie.setData('UCENTER_IUCTOKEN', json.data.token, 30 * 24 * 3600);
					}
					// document.getElementsByClassName('app-container')[0].style.position = 'fixed';
					
				} else {
					message.error(json.message);
				}
			});
	};

	render() {
		const {
			remember
		} = this.state;
		return(
			<div className="page-login" style={{position: 'fixed', top: 0, right: 0, bottom: 0, left: 0, background: '#f7fbff', zIndex: 2000}}>
                <img className="left-ball" src="https://appd.knowbox.cn/ss/pcSide/login_left_ball.png"
                     width={102}/>
                <img className="right-ball" src="https://appd.knowbox.cn/ss/pcSide/login_right_ball.png"
                     width={204}/>
                <div className="login-content">
                    <div className="login-outer-box vertical-center">
                        <div className="login-inner-box">
                            <div style={{padding: '56px 0', textAlign: 'center', position: 'relative'}}>
                                <div style={{display: 'inline-block', height: 60}}>
                                    <img src="https://appd.knowbox.cn/ss/pcSide/logo.png" width={243}
                                         height={60}/>
                                </div>
                            </div>
                            <div style={{width: 386, margin: 'auto'}}>
                                <div className="input-content input-content-phone" style={{borderBottom: 'none'}}>
                                    <div className="input-icon"><span className="icon-phone vertical-center"/></div>
                                    <div className="input-box">
                                        <input placeholder="输入手机号" maxLength={11}
                                               className="login-input login-input-phone"/>
                                        <span className="login-msg mobile-msg">手机号码（11位）</span>
                                    </div>
                                </div>
                                <div className="input-content input-content-password">
                                    <div className="input-icon"><span className="icon-password vertical-center"/></div>
                                    <div className="input-box">
                                        <input type="password" placeholder="输入密码" minLength={6} maxLength={20}
                                               className="login-input login-input-password"
                                        />
                                        {/*autoComplete="new-password"/>*/}
                                        <span className="login-msg password-msg">密码（6-20位）</span>
                                    </div>
                                </div>
                                <button className="login-button" onClick={this.doLogin} onKeyDown={this.onKeyDown}>登 录
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
		)
	}
}

const mapDispatchToProps = dispatch => {
	return {
		getUserInfo: () => {
			dispatch(userInfoAction.getUserInfo())
		}
	}
};
export default connect(null, mapDispatchToProps)(Login);


// WEBPACK FOOTER //
// ./src/login/view.js